"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function bze(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M10.464 18.3458H6.198L7.035 13.6095L11.4637 9.62025H7.69725L10.743 7.7535H15.6952L9.29025 14.076L8.85975 16.491C8.85975 16.491 10.29 16.596 11.4172 16.491C12.5452 16.3748 13.812 15.9083 13.812 15.9083L10.464 18.3458ZM17.172 8.20875L15.2655 10.0755C15.2655 10.0755 16.8698 11.8605 15.393 14.31C13.9402 16.713 9.1155 16.2698 9.1155 16.2698L9.4875 14.1585L16.2765 7.53225H10.65L11.22 4.3125H8.49975L7.52325 9.81825H10.9875L6.87225 13.5285L6 18.5213C6 18.5213 9.29025 18.6143 12.0803 18.5213C14.8815 18.4275 18.1477 16.0245 18.6248 13.3065C19.2758 9.6315 17.172 8.20875 17.172 8.20875Z", fill: color }),
        React.createElement("path", { d: "M10.0891 18.9083H5.82312L6.66012 14.172L11.0889 10.1828H7.32237L10.3681 8.316H15.3204L8.91537 14.6385L8.48487 17.0535C8.48487 17.0535 9.91512 17.1585 11.0424 17.0535C12.1704 16.9373 13.4371 16.4708 13.4371 16.4708L10.0891 18.9083ZM16.7971 8.77125L14.8906 10.638C14.8906 10.638 16.4949 12.423 15.0181 14.8725C13.5654 17.2755 8.74062 16.8323 8.74062 16.8323L9.11262 14.721L15.9016 8.09475H10.2751L10.8451 4.875H8.12487L7.14837 10.3808H10.6126L6.49737 14.091L5.62512 19.0838C5.62512 19.0838 8.91537 19.1768 11.7054 19.0838C14.5066 18.99 17.7729 16.587 18.2499 13.869C18.9009 10.194 16.7971 8.77125 16.7971 8.77125Z", fill: color }));
}
exports["default"] = bze;
//# sourceMappingURL=bze.js.map